import * as React from 'react'
import clsx from 'clsx'
import { makeStyles } from 'tss-react/mui'
import { classToFComponent, FCClassContext, ToolbarDivider, ToolbarSectionTitleResponsive } from 'src/utils/views'

import { HeaderScope } from '../tcm_scopes'

import HeaderSearchBarView from './tcm_header_search_bar'

const useStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'stretch',
        flexGrow: 1,
        gap: 12,
        marginLeft: 5,
        minWidth: 0,
        width: 0
    },
    searchBar: {
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: 0,
        minWidth: 220,
        '@media (max-width: 720px)': { display: 'none' }
    }
}))

type HeaderProps = {
    className?: string
    scope: HeaderScope
}

class HeaderViewClass implements FCClassContext<HeaderProps> {
    // :: Fields

    scope!: HeaderScope

    // :: Methods

    onSyncState({ scope }: HeaderProps) {
        this.scope = scope
    }

    render(props: HeaderProps): React.JSX.Element {
        const classes = useStyles().classes
        const scope = this.scope

        return (
            <div className={clsx(classes.view, props.className)}>
                <ToolbarDivider orientation="vertical" variant="middle" flexItem />
                <ToolbarSectionTitleResponsive>Mercado IA</ToolbarSectionTitleResponsive>
                {scope.textualSearch && (
                    <div className={classes.searchBar}>
                        <HeaderSearchBarView scope={scope.textualSearch} />
                    </div>
                )}
            </div>
        )
    }
}
export const HeaderView = classToFComponent(HeaderViewClass, React)
export default HeaderView
